package com.wintermar.inspection

import com.wintermar.inspection.util.ClientType

class JsPlatform : Platform {
    override val name: String = "Web with Kotlin/JS"
    override val clientType: ClientType = ClientType.APP
}

actual fun getPlatform(): Platform = JsPlatform()
